import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BlogService } from '../../services/blog.service';
import { Blog } from '../../core/models/blog.model';
import { NewsletterComponent } from '../../shared/components/newsletter/newsletter.component';

@Component({
  selector: 'app-blog-list',
  standalone: true,
  imports: [RouterLink, CommonModule, NewsletterComponent],
  templateUrl: './blog-list.component.html',
  styleUrl: './blog-list.component.css'
})
export class BlogListComponent implements OnInit {
  blogs: Blog[] = [];
  loading = true;
  error: string | null = null;

  constructor(private blogService: BlogService) {}

  ngOnInit(): void {
    this.loadBlogs();
  }

  loadBlogs(): void {
    this.loading = true;
    this.error = null;

    this.blogService.getPublishedBlogs().subscribe({
      next: (blogs) => {
        this.blogs = blogs;
        this.loading = false;
      },
      error: (error) => {
        this.error = 'Bloglar yüklenirken bir hata oluştu.';
        this.loading = false;
      }
    });
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    return date.toLocaleDateString('tr-TR', options);
  }

  getShortDescription(content: string, maxLength: number = 150): string {
    if (!content) return '';
    // HTML etiketlerini temizle
    const textContent = content.replace(/<[^>]*>/g, '').trim();
    if (textContent.length <= maxLength) return textContent;
    return textContent.substring(0, maxLength) + '...';
  }

  getDefaultImage(index: number): string {
    const images = [
      'assets/img/blog/list-2/1.png',
      'assets/img/blog/list-2/2.png',
      'assets/img/blog/list-2/3.png',
      'assets/img/blog/list-2/4.png',
      'assets/img/blog/list-2/5.png'
    ];
    return images[index % images.length];
  }

  getBlogImage(blog: Blog, index: number): string {
    // API'den gelen coverImage varsa onu kullan
    const coverImageUrl = this.blogService.getImageUrl(blog.coverImage);
    if (coverImageUrl) {
      return coverImageUrl;
    }
    
    // coverImage yoksa default placeholder image kullan
    return this.getDefaultImage(index);
  }

  getCoverImage(blog: Blog): string | null {
    return this.blogService.getImageUrl(blog.coverImage);
  }
}

